import { render } from "./AdminCockpitNavigationListItem.vue?vue&type=template&id=6026a780&ts=true"
import script from "./AdminCockpitNavigationListItem.vue?vue&type=script&lang=ts"
export * from "./AdminCockpitNavigationListItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__